module.exports = __webpack_public_path__ + "static/media/matic.97e1612f.svg";